export default __webpack_public_path__ + "static/media/dec2023-1.97d3df1d.jpg";